import { Component } from '@angular/core';
import { MenuItemComponent } from 'projects/max/dfup-storeupweb-fe/src/app/component/menu/menu-item/menu-item.component';

@Component({
  selector: 'app-menu-item-desktop',
  templateUrl: './menu-item-desktop.component.html',
  styleUrls: ['./menu-item-desktop.component.scss']
})
export class MenuItemDesktopComponent extends MenuItemComponent {
}
